export default "__VITE_ASSET__3257d6de__"